import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-tree-structure-icon',
  templateUrl: 'tree-structure-icon.component.html'
})
export class TreeStructureIconComponent {
  constructor() {}
}
